import React from "react";
import { SETTINGS } from "../config/settings";
function Footer(props) {
  return (
    <footer className="text-center">
      &copy; Copyright {new Date().getFullYear()}
      <a href={SETTINGS.developer.company} target="_blank">
        {SETTINGS.TITLE}
      </a>{" "}
      all rights reserved
    </footer>
  );
}

export default Footer;
